import { createEntityApi } from '@/shared/lib'
import { API } from '@/apps/adok/shared/api'

import type { UserNote } from '../model/types'

export interface CreateUserNotePayload {
  text: string
  notifyAt: string | null
}

export const { getItems, createItem } = createEntityApi<
  UserNote,
  CreateUserNotePayload
>({ endpoint: API.adminUserNotes })
